<template>
  <el-container class="container">
    <el-main class="flex flex1 flex-column main">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-position="right"
               label-width="110px">
        <!-- 名称 -->
        <el-form-item label="项目" prop="id">
          <options-select
              v-model="queryParams.id"
              @change="projectChange"
              :options="projectOptions"
              placeholder="请选择系统模块"
              size="small"
              clearable
          />
        </el-form-item>
      </el-form>
      <div class="flex flex-wrap">
        <div class="card flex flex-column">
          <div class="card_title">
            系统模块
          </div>
          <div class="">
            <div style="margin-left: 15px;margin-top: 5px;">加急开发中，敬请期待...</div>
          </div>
        </div>
      </div>
    </el-main>
    <div style="width: 10px;"></div>
    <el-aside class="aside" width="372px">
      <div style="font-size: medium;font-weight: bolder;text-align: center;margin: 15px 10px 0;">智慧功能</div>
      <AICreateTableButton class="function_btn" style="margin: 0; margin-top: 15px;">智能建表</AICreateTableButton>
      <AICreateCodeButton class="function_btn" style="margin: 0; margin-top: 15px;">智能生成代码</AICreateCodeButton>
      <el-button type="warning" plain class="function_btn">便捷开发</el-button>
      <el-button type="success" plain class="function_btn">人脸SDK集成项目下载</el-button>
      <el-button type="primary" plain class="function_btn">查看模块详情</el-button>
    </el-aside>
  </el-container>
</template>

<script>
import AICreateTableButton from "@/views/data/workSpace/components/AICreateTableButton.vue";
import AICreateCodeButton from "@/views/data/workSpace/components/AICreateCodeButton.vue";
export default {
  components: {
    AICreateTableButton,
    AICreateCodeButton
  },
  name: "WorkSpace",
  // 名称，版本号，文字简介（200字），超链简介，创建日期，作者（昵称），作者链接（网页地址，超链），下载链接（）
  data() {
    return {
      queryParams: {
        // 用户当前项目
        id: "1429768794338242562"
      },
      projectOptions: [
          { id: "1429768794338242562", name: '模块1' },
          { id: "2142976879433824256", name: '模块2' },
          { id: "3142976879433824256", name: '模块3' },
      ]
    }
  },
  methods: {
    projectChange() {
      // 项目改变时，模块选项清空
      this.queryParams.id = "";
      console.log(this.queryParams.id);
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    height: 100%;
    //border: solid #dcdfe6 1px;
    border-radius: 8px;
    .main {
      height: 100%;
      align-content: flex-start;
      overflow:auto;
      border: solid #dcdfe6 1px;
      border-radius: 8px;
      padding-left: 2px;
      padding-top: 15px;
      padding-bottom: 8px;
      background: #F1F5FB;
      .card {
        height: 230px;
        //width: 18%;
        border: solid #dcdfe6 1px;
        margin-bottom: 8px;
        background: #FFFFFF;
        margin-left: 8px;
        border-radius: 8px;
        padding: 4px;
        .card_title {
          font-weight: bolder;
          font-size: medium;
          //text-align: center;
          margin: 10px 4px 4px 16px;
        }
      }
    }
    .aside {
      background: #F1F5FB;
      border-radius: 8px;
      border: solid #dcdfe6 1px;
      padding: 10px 10px 8px;
      .function_btn {
        width: 100%;
        margin-top: 15px;
        margin-left: 0;
      }
    }
  }
</style>